import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import SideNavigation from "../../Menu-sidenavbar/SideNavigation ";
import HeaderBackground from "../../../common/SubpagesBGimage";
import Footer from "../../Layout/Footer";
import Header from "../../Layout/Header";
import { StatutoryCommitteeActions } from "../../../Store/Statutory Committee/action";

function AntiDrugCommittee() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
   document.title = "Anti Drug Committe | PSG-IAP"
  const dispatch = useDispatch();
  const statutorySubpage = useSelector(
    (state) => state.StatutoryCommitteeReducer.StatutoryCommitteeSubpage
  );

  useEffect(() => {
    dispatch({
      type: StatutoryCommitteeActions.GET_STATUTORY_COMMITTEE_SUBPAGE,
    });
  }, [dispatch]);

  //  Get the "Anti-Drug Committee" data from API
  const committeeData = statutorySubpage.find(
    (item) => item.map_name === "Anti-Drug Committee"
  );

  if (!committeeData) {
    return <div className="text-center mt-5"></div>;
  }

  const departments = committeeData?.departments || [];
  return (
    <div>
      <HeaderBackground
        menuName="About Us"
        subMenuName="Statutory Committee"
        thirdLevelName="Anti Drug Committee"
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
      />
      <Header />

      <div className="statutory">
        <div className="container committee-container">
          <h6 className="rectangle-title">
            <span className="rectangle-marker"></span>
            {committeeData.committee_name}
          </h6>
        
          <hr />

          {/* Dynamic Departments and Members */}
          {departments.map((dept, deptIdx) => (
            <div key={deptIdx} className="mb-5">
              <h5 className="mt-4 text-start subb-title">{dept.department_name}</h5>
              <div className="row mt-3">
                {dept.members
                  .filter(
                    (m) =>
                      m.committee !== "Year / Semester" &&
                      m.committee !== "Year/Sem"
                  )
                  .map((member, idx) => (
                     <div className="col-12 col-sm-6 col-lg-4 mb-4" key={idx}>
                      <div className="card member-card text-left p-4 shadow-sm">
                        <h5 className="member-name">{member.member_name}</h5>
                        {member.designation && (
                          <p className="member-title">{member.designation}</p>
                        )}
                        {member.committee && (
                          <p className="member-role">{member.committee}</p>
                        )}
                        {member.phone && (
                          <p className="member-text">
                            <span className="label-blue">Mobile No:</span>{" "}
                            <span className="value-grey">{member.phone}</span>
                          </p>
                        )}
                        {member.email && (
                          <p className="member-text">
                            <span className="label-blue">E-mail:</span>{" "}
                            <span className="value-grey">{member.email}</span>
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ))}

  
            {/* Dynamic Committee Content */}
             {committeeData?.content ? (
             <div className="committee-content mt-4 rect-text"
             style={{
                textAlign: "justify",
                fontSize: "16px",
                lineHeight: "26px",
                color: "#333",
                marginBottom: "10px",
                fontFamily: "Poppins, sans-serif",
                 }}>
             <div className="table-responsive"
              dangerouslySetInnerHTML={{ __html: committeeData.content }} />
            </div>
           ) : (
           <p className="text-center mt-4 text-muted">No content available.</p>
           )}
        </div>
      </div>

      <SideNavigation
        key="About Us"
        isMenuOpen={isMenuOpen}
        handleMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
        openKeys={openKeys}
        onOpenChange={setOpenKeys}
        defaultOpenSubMenu="About Us"
      />
      <Footer />
    </div>
  );
}

export default AntiDrugCommittee;


